module.exports = __webpack_public_path__ + "img/payment-calendar.8490d196.svg";